/**
 * @generated SignedSource<<c27fbbaaa14fcd845cb88463877b689f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type CommentRendererReadFragmentWithAppKey$data = {
  readonly nodes: ReadonlyArray<{
    readonly contentId: string;
    readonly macroId: string;
    readonly renderedMacro: {
      readonly appKey: string | null;
      readonly macroBodyStorage: string | null;
      readonly macroRenderedRepresentation: ContentRepresentationV2 | null;
      readonly mediaToken: {
        readonly token: string | null;
      } | null;
      readonly value: string | null;
      readonly webResource: {
        readonly contexts: ReadonlyArray<string | null>;
        readonly keys: ReadonlyArray<string | null>;
        readonly superbatch: {
          readonly metatags: string | null;
        } | null;
        readonly tags: {
          readonly css: string | null;
          readonly data: string | null;
          readonly js: string | null;
        } | null;
        readonly uris: {
          readonly css: ReadonlyArray<string | null> | null;
          readonly data: ReadonlyArray<string | null> | null;
          readonly js: ReadonlyArray<string | null> | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
  readonly pageInfo: {
    readonly __typename: "PageInfoV2";
    readonly endCursor: string | null;
    readonly hasNextPage: boolean;
  };
  readonly " $fragmentType": "CommentRendererReadFragmentWithAppKey";
};
export type CommentRendererReadFragmentWithAppKey$key = {
  readonly " $data"?: CommentRendererReadFragmentWithAppKey$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentRendererReadFragmentWithAppKey">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentRendererReadFragmentWithAppKey",
  "selections": [
    {
      "concreteType": "Macro",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "macroId"
        },
        {
          "kind": "ScalarField",
          "name": "contentId"
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "mode",
              "value": "RENDERER"
            }
          ],
          "concreteType": "RenderedMacro",
          "kind": "LinkedField",
          "name": "renderedMacro",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "appKey"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "macroRenderedRepresentation"
            },
            {
              "kind": "ScalarField",
              "name": "macroBodyStorage"
            },
            {
              "concreteType": "WebResourceDependenciesV2",
              "kind": "LinkedField",
              "name": "webResource",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "contexts"
                },
                {
                  "kind": "ScalarField",
                  "name": "keys"
                },
                {
                  "concreteType": "SuperBatchWebResourcesV2",
                  "kind": "LinkedField",
                  "name": "superbatch",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "metatags"
                    }
                  ]
                },
                {
                  "concreteType": "WebResourceTagsV2",
                  "kind": "LinkedField",
                  "name": "tags",
                  "plural": false,
                  "selections": (v0/*: any*/)
                },
                {
                  "concreteType": "WebResourceUrisV2",
                  "kind": "LinkedField",
                  "name": "uris",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            },
            {
              "concreteType": "EmbeddedMediaTokenV2",
              "kind": "LinkedField",
              "name": "mediaToken",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "token"
                }
              ]
            }
          ],
          "storageKey": "renderedMacro(mode:\"RENDERER\")"
        }
      ]
    },
    {
      "concreteType": "PageInfoV2",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "MacroConnection"
};
})();

(node as any).hash = "baa5be0493f483d10c38df29c48e3340";

export default node;
